import { getbadgenum,crmMessagNumAPI } from '@/api/customer/customer'

/**
 * 消息记录
 */
const app = {
	state: {
		// 详情的角标
		badgeNum: {
			id:0,
			record: 0,
			tolawcase: 0
		},
		// 待办事项消息
		messageNum: {
		    todayCustomer: 0,
		    totalNum: 0
		}
	},

	mutations: {
		
		/**
		 * 更改角标
		 */
		SET_BADGENUM: (state, badgeNum) => {
			state.badgeNum = badgeNum
		},
		
		// 角标+1
		increment:(state, type) => {
			state.badgeNum[type]++
		},
		
		// 角标-1
		descrement:(state, type) => {
			state.badgeNum[type]--
		},
		
		// 清空数据
		emptybadge:(state) => {
			state.badgeNum = {
				id:0,
				record: 0,
				tolawcase: 0
			}
		},
		
		/**
		 * 更改待办事项
		 */
		SET_MESSAGENUM: (state, messageNum) => {
			let totalNum = 0
			for (let key in messageNum) {
				if (key != 'totalNum') {
					totalNum += (messageNum[key] || 0)
				}
			}
			messageNum.totalNum = totalNum
			state.messageNum = messageNum
		}
	},

	actions: {
		// 角标
		GetCustomerBadgeNum({
			commit
		}, id) {
			return new Promise((resolve, reject) => {
				getbadgenum({id:id})
					.then(response => {
						commit('SET_BADGENUM', response.data)
						resolve(response)
					})
					.catch(error => {
						reject(error)
					})
			})
		},
		
		// 获取待办事项
		GetMessageNum({
			state,
			commit
		}) {
			return new Promise((resolve, reject) => {
				crmMessagNumAPI()
					.then(response => {
						commit('SET_MESSAGENUM', response.data)
						commit('SET_CRMCUSTOMERROUTERSNUM', state.messageNum.totalNum)
						resolve(response)
					})
					.catch(error => {
						reject(error)
					})
			})
		}
	}
}

export default app
